import { post } from "./base";
import { get } from "./base";

//生成支付到的二维码
export function createCode(params) {
    let respObj = post("api/pay/code",params);
    return respObj;
}

//查询支付状态
export async function payQuery(params) {
    let respObj = await post("api/pay/query",params);
    return respObj;
}

//申请退款
export async function refund(params){
    let respObj = await post("api/pay/refund",params);
    return respObj;
}
//退款原因描述 /api/pay/remark
export async function getRemark(){
    let respObj = await get("api/pay/remark");
    return respObj;
}